<template>
  <div class="login" v-loading.fullscreen.lock="fullscreenLoading">
    <div class="register" style="height: 702px">
      <div class="title">
        注册账号
        <span class="link" @click="$router.push({ name: 'login' })"
          >已有账号，去登录
          <img
            style="width: 8px; height: 14px; margin-left: 8px"
            src="../assets/right-icon.png"
            alt=""
          />
        </span>
      </div>
      <div class="input">
        <el-input
          class="password"
          placeholder="请输入手机号"
          v-model="form.phone"
        ></el-input>
      </div>
      <div class="input" style="margin-top: 32px">
        <el-input
          class="password"
          placeholder="请输入验证码"
          v-model="form.smsVerifyCode"
        ></el-input>

        <el-button
          class="code"
          type="primary"
          :disabled="pending"
          @click="onVerifyCode"
        >
          {{ pending ? ss : "获取验证码" }}
        </el-button>
      </div>
      <div class="input" style="margin-top: 32px">
        <el-input
          class="password"
          :type="isShow ? 'text' : 'password'"
          placeholder="密码(8-20位)"
          v-model="form.password"
        ></el-input>
        <div
          style="
            width: 30px;
            display: flex;
            align-items: center;
            cursor: pointer;
          "
          @click="isShow = !isShow"
        >
          <img
            src="../assets/eye-0.png"
            v-if="!isShow"
            style="width: 20px; height: 16px"
            alt=""
          />
          <img
            src="../assets/eye-1.png"
            v-else
            style="width: 20px; height: 14px"
            alt=""
          />
        </div>
      </div>
      <div class="input" style="margin-top: 32px">
        <el-input
          class="password"
          :type="isShow ? 'text' : 'password'"
          placeholder="确认密码"
          v-model="form.pass"
        ></el-input>
        <div
          style="
            width: 30px;
            display: flex;
            align-items: center;
            cursor: pointer;
          "
          @click="isShow = !isShow"
        >
          <img
            src="../assets/eye-0.png"
            v-if="!isShow"
            style="width: 20px; height: 16px"
            alt=""
          />
          <img
            src="../assets/eye-1.png"
            v-else
            style="width: 20px; height: 14px"
            alt=""
          />
        </div>
      </div>
      <p class="error">{{ error }}</p>
      <el-checkbox class="checkbox" v-model="checked">
        我已认真阅读并同意
      </el-checkbox>
      <a
        class="file"
        href="javascript:;"
        @click="
          onViewPdf(loginSetting.platformUserAgreementUrl, '平台用户协议')
        "
      >
        《平台用户协议》
      </a>
      <a
        class="file"
        href="javascript:;"
        @click="onViewPdf(loginSetting.privacyStatement, '隐私保护声明')"
      >
        《隐私保护声明》
      </a>
      <p class="login-btn" @click="onRegister">注册</p>
    </div>

    <el-dialog
      :visible.sync="visible"
      :title="dialogTitle"
      :custom-class="'work-dialog'"
      fullscreen
      @close="onWorkDialogClose"
    >
      <PdfViewer :key="pdfUrl" :pdf-url="pdfUrl" />
    </el-dialog>
  </div>
</template>

<script>
import { register } from "../api/user";
import { getVerifyCode } from "../api/sms";
import { getSiteConfig } from "@/api/common";
import PdfViewer from "@/components/pdf-viewer";

export default {
  name: "Register",
  components: { PdfViewer },
  data() {
    return {
      isShow: false,
      fullscreenLoading: false,
      checked: false,
      form: {
        phone: "",
        password: "",
        smsVerifyCode: "",
        pass: "",
      },
      error: "",

      loginSetting: {},

      dialogTitle: "",
      visible: false,

      pdfUrl: "",

      pending: false,

      ss: 60,

      timer: null,
    };
  },
  created() {
    this.getSiteConfig();
  },

  methods: {
    onVerifyCode() {
      if (!this.form.phone) {
        return this.$message.warning("请输入手机号码");
      }

      if (!/^1[3-9]\d{9}$/.test(this.form.phone)) {
        return this.$message.warning("请输入有效的手机号码");
      }

      getVerifyCode(this.form.phone, "register").then(() => {
        this.pending = true;
        this.timer = setInterval(() => {
          if (this.ss === 0) {
            this.pending = false;
            this.ss = 60;
            clearInterval(this.timer);
          }
          this.ss--;
        }, 1000);
      });
    },
    onWorkDialogClose() {},
    onViewPdf(pdfUrl, title) {
      this.pdfUrl = pdfUrl;
      this.dialogTitle = title;
      this.visible = true;
    },
    getSiteConfig() {
      getSiteConfig().then(({ data }) => {
        this.loginSetting = data.login;
      });
    },
    onRegister() {
      if (!this.form.phone) {
        return (this.error = "请输入参赛选手报名手机号");
      }

      if (!/^1[3-9]\d{9}$/.test(this.form.phone)) {
        return (this.error = "请输入有效的手机号码");
      }

      if (!this.form.smsVerifyCode) {
        return (this.error = "请输入验证码");
      }

      if (!this.form.password) {
        return (this.error = "请输入密码");
      }

      if (this.form.password.length > 20 || this.form.password.length < 8) {
        return (this.error = "密码长度为8-20");
      }

      if (this.form.password !== this.form.pass) {
        return (this.error = "两次输入密码不一致");
      }

      if (!this.checked) {
        return (this.error = "请阅读协议");
      }

      this.error = "";
      register(this.form).then(() => {
        this.$message.success("注册成功");
        this.$router.push({ name: "login", query: { type: 1 } });
      });
    },
  },
  destroyed() {
    clearInterval(this.timer);
  },
};
</script>

<style scoped>
::v-deep .work-dialog .el-dialog__body {
  height: calc(100vh - 54px);
  padding: 10px 20px;
  display: flex;
  flex-direction: column;
}

.code {
  height: 32px;
  padding: 0 10px;
  background: #046bde;
  font-weight: 400;
  font-size: 14px;
  line-height: 22px;
  text-align: left;
  font-style: normal;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 18px;
  cursor: pointer;
  white-space: nowrap;
  border: 0 none;
}
.tip {
  font-size: 14px;
  font-weight: 400;
  color: #788a9f;
  line-height: 21px;
  margin-top: 24px;
}
.login-btn {
  width: 400px;
  height: 40px;
  background: #046bde;
  border-radius: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  font-weight: 400;
  color: #ffffff;
  line-height: 24px;
  margin-top: 32px;
  cursor: pointer;
}
.checkbox {
  margin-top: 40px;
}
.file {
  font-size: 14px;
  font-weight: 400;
  color: #046bde;
  line-height: 22px;
}
.error {
  height: 14px;
  font-size: 14px;
  font-weight: 400;
  color: #f95155;
  line-height: 14px;
  margin: 8px 0 0 24px;
}
.username-tip {
  display: flex;
  margin: 10px 0;
}
.username-tip img {
  width: 16px;
  height: 16px;
  margin-top: 2px;
  margin-right: 5px;
}
.username-tip p {
  font-size: 14px;
  font-weight: 400;
  color: #788a9f;
  line-height: 21px;
}
.username {
  margin-top: 40px;
}
.login {
  width: 100%;
  height: 100vh;
  background: #171f30;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: auto;
  padding: 100px 0;
}
.background-style {
  background-color: #171f30; /* 设置背景颜色 */
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  overflow-y: auto;
}
.register {
  width: 520px;
  height: 592px;
  border: 1px solid #046bde;
  border-radius: 20px;
  padding: 90px 60px 50px;
}
.link {
  font-weight: 400;
  font-size: 16px;
  color: #046bde;
  line-height: 14px;
  text-align: left;
  font-style: normal;
  display: flex;
  align-items: center;
  margin-left: 20px;
  cursor: pointer;
}
.title {
  font-size: 30px;
  font-weight: 600;
  color: #ffffff;
  line-height: 30px;
  margin-bottom: 40px;
  display: flex;
}
::v-deep .el-input__inner {
  background: transparent;
  border: none !important;
  /* color: #fff; */
  font-size: 16px !important;
  font-weight: 400;
  color: #909399;
  line-height: 16px;
}
.input {
  font-size: 16px !important;
  font-weight: 400;
  color: #909399;
  line-height: 16px;
  background: #0a2b51 !important;
  border-radius: 25px !important;
  border: 1px solid #046bde !important;
  height: 50px !important;
  padding: 0 10px !important;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
</style>
